(function ($, UX) {
    let $body = $('body');

    var bookProduct = {
        init: function () {
            bookProduct.control();
        },
        control: function () {
            $body.on('click', '.book-product__content button', function (e) {
                bookProduct.showOverlay($(this));
            });
            $body.on('click', '.book-product__overlay a', function (e) {
                bookProduct.hideOverlay($(this));
            });
        },
        showOverlay: function ($this) {
            $this.closest('.book-product').find('.book-product__overlay').show();
        },
        hideOverlay: function ($this) {
            $this.closest('.book-product__overlay').hide();
        },
    };

    UX.bookProduct = bookProduct;
    // init self on ready
    $(document).ready(UX.bookProduct.init);
})(jQuery, UX);
